import { genreActionTypes as types } from 'src/redux/actions/genreActions';

const initialState = {
  loading: false,
  error: null,
  genres: {},
};

export default function genreReducer(state = initialState, { type, data, error, payload }) {
  switch (type) {
    case types.FETCH_GENRES_REQUEST:
    case types.ADD_GENRE_REQUEST:
    case types.EDIT_GENRE_REQUEST:
    case types.DELETE_GENRES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case types.FETCH_GENRES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        genres: data
      }
    case types.ADD_GENRE_SUCCESS:
    case types.EDIT_GENRE_SUCCESS:
    case types.DELETE_GENRES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      }
    case types.FETCH_GENRES_FAILURE:
    case types.ADD_GENRE_FAILURE:
    case types.EDIT_GENRE_FAILURE:
    case types.DELETE_GENRES_FAILURE:
      return {
        ...state,
        loading: false,
        error
      }
    default:
      return state;
  }
}
